import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import WorkspacePage from "./pages/WorkspacePage";
import ProfilePage from "./pages/ProfilePage";
import AdminPage from "./pages/AdminPage";
import SharedDiagnosticPage from "./pages/SharedDiagnosticPage";
import PricingPage from "./pages/PricingPage";
import CataloguePage from "./pages/CataloguePage";
import BillingSuccessPage from "./pages/BillingSuccessPage";
import BillingHistoryPage from "./pages/BillingHistoryPage";
import BrandingPage from "./pages/BrandingPage";
import SuperAdminPage from "./pages/SuperAdminPage";
import ToolWorkspacePage from "./pages/ToolWorkspacePage";
import ClientPortalPage from "./pages/ClientPortalPage";
import CompanyOverviewPage from "./pages/CompanyOverviewPage";
import BenchmarkPage from "./pages/BenchmarkPage";
import DocsIndexPage from "./pages/DocsIndexPage";
import DocPage from "./pages/DocPage";

import LandingPage from "./pages/LandingPage";

function HomeOrLanding() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-cream flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 border-sage-500 border-t-transparent rounded-full animate-spin" />
          <p className="text-sage-500 font-body text-sm">Loading TheKaizenCabinet…</p>
        </div>
      </div>
    );
  }
  return user ? <DashboardPage /> : <LandingPage />;
}

function ProtectedRoute({ children, adminOnly = false, superOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-cream flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 border-sage-500 border-t-transparent rounded-full animate-spin" />
          <p className="text-sage-500 font-body text-sm">Loading TheKaizenCabinet…</p>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (superOnly && user.role !== "superadmin") return <Navigate to="/" replace />;
  if (adminOnly && !["admin", "superadmin"].includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/share/:token" element={<SharedDiagnosticPage />} />
          <Route path="/portal/:token" element={<ClientPortalPage />} />
          <Route path="/" element={<HomeOrLanding />} />
          <Route path="/welcome" element={<LandingPage />} />
          <Route path="/workspace/:companyId" element={<ProtectedRoute><CompanyOverviewPage /></ProtectedRoute>} />
          <Route path="/workspace/:companyId/project/:projectId" element={<ProtectedRoute><WorkspacePage /></ProtectedRoute>} />
          <Route path="/tool/:companyId/project/:projectId" element={<ProtectedRoute><ToolWorkspacePage /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
          <Route path="/catalogue" element={<ProtectedRoute><CataloguePage /></ProtectedRoute>} />
          <Route path="/pricing" element={<ProtectedRoute><PricingPage /></ProtectedRoute>} />
          <Route path="/billing" element={<ProtectedRoute><BillingHistoryPage /></ProtectedRoute>} />
          <Route path="/billing/success" element={<ProtectedRoute><BillingSuccessPage /></ProtectedRoute>} />
          <Route path="/branding" element={<ProtectedRoute><BrandingPage /></ProtectedRoute>} />
          <Route path="/benchmark" element={<ProtectedRoute><BenchmarkPage /></ProtectedRoute>} />
          <Route path="/docs" element={<ProtectedRoute><DocsIndexPage /></ProtectedRoute>} />
          <Route path="/docs/:toolId" element={<ProtectedRoute><DocPage /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute adminOnly><AdminPage /></ProtectedRoute>} />
          <Route path="/superadmin" element={<ProtectedRoute superOnly><SuperAdminPage /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
